<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-02-07 15:34:56
 * @FilePath: /wemeet-admin-new/src/views/marketing/components/LotteryList.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="姓名" prop="name" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.name ? row.name : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone" show-overflow-tooltip />
      <el-table-column label="是否核销" prop="status" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.status ? `已核销` : '未核销' }}
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="请输入手机号，查询用户后再投放" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { getPrizesStatistics } from '@/api/exhibitionManage'
  import wmtImage from '@/components/wmt-image'
  import VueCropper from '@/extra/VueCropper'
  export default defineComponent({
    name: 'SendMessage',
    components: {
      wmtImage,
      VueCropper,
    },
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
      meetingType: {
        type: String,
        default: 'EXHIBITION',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        listLoading: false,
        layout: 'total, sizes, prev, pager, next, jumper',
        list: [],
        queryForm: {
          pageNum: 1,
          pageSize: 10,
        },
        dialogFormVisible: false,
        direction: 'rtl',
        size: '50%',
        detail: {
          attentFormDtoList: [],
        },
        title: '奖品领取详情',
        rules: {
          dailyLimit: [{ required: true, message: '请填写每日限额', trigger: 'blur' }],
          name: [{ required: true, message: '请填写奖品名称', trigger: 'blur' }],
          probability: [{ required: true, message: '请填写中奖概率', trigger: 'blur' }],
          stock: [{ required: true, message: '请填写库存', trigger: 'blur' }],
        },

        form: {
          reason: '',
          imgUrl: '',
        },
        reasonRef: null,
        row: null,
        labelPosition: 'left',
        vabCropperRef: null,
      })
      // 打开
      const handleOpen = async (row) => {
        state.queryForm.prizeId = row.id
        state.queryForm.meetingCode = props.meetingCode
        fetchData()
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.imgUrl = ''
        state.dialogFormVisible = false
      }

      const fetchData = async () => {
        state.listLoading = true
        try {
          const { data } = await getPrizesStatistics(state.queryForm)
          state.list = data.list
        } catch (e) {
          state.listLoading = false
          state.list = []
        }
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleSizeChange,
        handleCurrentChange,
        fetchData,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }

  .basicMessage {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 50px;
    .desc {
      margin: 0 10px;
    }
  }
</style>
